module.exports = __webpack_public_path__ + "static/media/restaurantero-logo-white.a6207395.png";